import { render, staticRenderFns } from "./PredictionTransference.vue?vue&type=template&id=724477ac"
import script from "./PredictionTransference.vue?vue&type=script&lang=js"
export * from "./PredictionTransference.vue?vue&type=script&lang=js"
import style0 from "./PredictionTransference.vue?vue&type=style&index=0&id=724477ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports